"use strict";

exports.__esModule = true;
exports.PlantStateActivitiesToolbar = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactIntl = require("react-intl");
var _icons = require("@blueprintjs/icons");
var _core = require("@blueprintjs/core");
var _System = require("../../../System");
var _getFilteredPlantStateActivitiesList = require("../getFilteredPlantStateActivitiesList");
var _Core = require("../../Core");
var _PlantStateActivitiesContext = require("../PlantStateActivitiesContext");
var _dec, _class, _PlantStateActivitiesToolbar;
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _inheritsLoose(t, o) { t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
/**
 * Plant state activities toolbar with filtering of activities
 */
var PlantStateActivitiesToolbar = exports.PlantStateActivitiesToolbar = (_dec = _PlantStateActivitiesContext.PlantStateActivitiesContext.withContext, _dec(_class = (_PlantStateActivitiesToolbar = /*#__PURE__*/function (_Component) {
  function PlantStateActivitiesToolbar() {
    return _Component.apply(this, arguments) || this;
  }
  _inheritsLoose(PlantStateActivitiesToolbar, _Component);
  var _proto = PlantStateActivitiesToolbar.prototype;
  _proto.render = function render() {
    var _this$props = this.props,
      plantStateActivities = _this$props.plantStateActivities,
      showCreateButton = _this$props.showCreateButton,
      onChangeEnabledToggle = _this$props.onChangeEnabledToggle,
      enabledFilterOn = _this$props.enabledFilterOn;
    var activities = (0, _getFilteredPlantStateActivitiesList.getFilteredPlantStateActivitiesList)(plantStateActivities);
    var activityCount = activities.filter(function (activity) {
      return activity.isEnabled === enabledFilterOn;
    }).length;
    return /*#__PURE__*/_react["default"].createElement(_Core.Toolbar, null, /*#__PURE__*/_react["default"].createElement(_Core.SearchInput, {
      onChange: plantStateActivities.onFilterChange,
      value: plantStateActivities.filterValue
    }), /*#__PURE__*/_react["default"].createElement(_Core.ToolbarDescription, null, /*#__PURE__*/_react["default"].createElement(_core.ButtonGroup, {
      minimal: true,
      style: {
        marginLeft: "1rem",
        marginRight: "1rem"
      }
    }, /*#__PURE__*/_react["default"].createElement(_core.Button, {
      type: "button",
      active: enabledFilterOn,
      text: /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
        id: "enabled",
        defaultMessage: "Enabled"
      }),
      onClick: function onClick() {
        return onChangeEnabledToggle(true);
      }
    }), /*#__PURE__*/_react["default"].createElement(_core.Button, {
      type: "button",
      active: !enabledFilterOn,
      text: /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
        id: "disabled",
        defaultMessage: "Disabled"
      }),
      onClick: function onClick() {
        return onChangeEnabledToggle(false);
      }
    })), /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
      id: "PlantStateActivitiesToolbar.activityCount",
      defaultMessage: "\n              {value} {activityCount, plural,\n                one {activity}\n                other {activities}\n              }\n            ",
      values: {
        value: /*#__PURE__*/_react["default"].createElement("strong", null, /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedNumber, {
          value: activityCount
        })),
        activityCount: activityCount
      }
    })), showCreateButton && /*#__PURE__*/_react["default"].createElement(_Core.LinkButton, {
      intent: _core.Intent.PRIMARY,
      icon: _icons.IconNames.ADD,
      to: (0, _System.getScreenURL)("CreatePlantStateActivities")
    }, /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
      style: {
        marginTop: "-7px"
      },
      id: "PlantStateActivitiesToolbar.createActivity",
      defaultMessage: "Create Activity"
    })));
  };
  return PlantStateActivitiesToolbar;
}(_react.Component), _PlantStateActivitiesToolbar.defaultProps = {
  showCreateButton: true,
  plantStateActivities: undefined
}, _PlantStateActivitiesToolbar)) || _class);